import styled from 'styled-components'

import { Section as SectionDS, Infos as InfosDS } from 'components/general-styles/General'
import { theme } from 'styles/theme'

const { colors, fontSizes, media, radii, space } = theme

export const Section = styled(SectionDS)`
  background-color: ${colors['neutral-background-strong']};
  padding-top: ${space['spacing-xxxl']};
  padding-bottom: ${space['spacing-xxxl']};

  @media (${media.tablet}) {
    padding-top: ${space['spacing-giga']};
    padding-bottom: ${space['spacing-giga']};
  }
`

export const Infos = styled(InfosDS)`
  & > .ds-button.quick-access {
    width: 100%;
    justify-content: center;
    border-radius: ${radii['corner-radius-pill']};
  }

  @media (${media.tablet}) {
    & > .ds-button.quick-access {
      max-width: 21.875rem;
    }
  }
`

export const ContentWrapper = styled.div`
  position: relative;
  display: flex;
  gap: ${space['spacing-md']};
  margin-bottom: ${space['spacing-md']};
  border-radius: ${radii['corner-radius-md']};
  border: 1px solid ${colors['neutral-text-contrast-default']};
  background-color: ${colors['neutral-background-contrast']};
  color: ${colors['neutral-text-contrast-default']};
  overflow: hidden;

  @media (${media.tablet}) {
    height: 450px;
    border: unset;
  }
`

export const CarouselWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 100%;
  gap: ${space['spacing-lg']};
  padding: ${space['spacing-md']};

  .controls-wrapper {
    .ds-button,
    li[data-state='active'] {
      background-color: ${colors['cyan-background-pressed']};
      color: ${colors['neutral-background-contrast']};
    }
  }

  @media (${media.tablet}) {
    max-width: 50%;

    .controls-wrapper {
      justify-content: normal;
    }
  }
`

export const CardsWrapper = styled.div`
  display: none;
  position: relative;
  width: 100%;
  bottom: 0;

  .swiper {
    height: 100%;

    .swiper-wrapper {
      transform: none !important;
    }
  }

  .swiper-slide {
    z-index: 1;
    position: absolute;
    left: 0;
    height: 370px;
    border-radius: ${radii['corner-radius-md']};
    object-fit: cover;
    object-position: center bottom;
    transform-origin: bottom left;
    transform: rotate(30deg);
    bottom: 100px;
  }

  .swiper-slide-active {
    z-index: 9;
    transform: rotate(0);
    bottom: 0;
  }

  .swiper-slide-next {
    z-index: 8;
    transform: rotate(15deg);
    bottom: 50px;

    & + div {
      z-index: 7;
    }
  }

  .swiper-slide:first-of-type:not(.swiper-slide-active, .swiper-slide-next) {
    z-index: 6;
  }

  img {
    object-fit: cover;
    border-radius: ${radii['corner-radius-md']};
  }

  @media (${media.tablet}) {
    display: block;
  }
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-md']};
  cursor: grab;

  @media (${media.tablet}) {
    h3 {
      font-size: ${fontSizes['font-size-heading-4']};
    }
  }
`
